import apiClient from "../../../utilities/apiClient";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";

export const get_notification = (payload) => {
  const role = LocalStorage.getItem(SESSION_KEY)?.roles[0];
  const isOfficerRole =
    role === ROLES.OFFICER ||
    role === ROLES.PROCUREMENT_BUYER ||
    role === ROLES.REQUESTOR;

  return apiClient.get(
    role === ROLES.USER
      ? `${apiClient.Urls.user_notification}`
      : isOfficerRole
      ? `${apiClient.Urls.officer_notification}`
      : `${apiClient.Urls.admin_notification}`,
    payload,
    true
  );
};
